export default "__VITE_ASSET__DtBQr9TX__"